import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const postLedger = async (ledgerData) => {
  try {
    const res = await API.post_ledger(ledgerData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateLedger = async (ID, ledgerData) => {
  try {
    const res = await API.update_publisher_ledger(ID, ledgerData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const ledgerListForPublisher = async (page, month, year) => {
  try {
    const res = await API.ledger_list_for_publisher(page, month, year);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const uploadInvoice = async (invoiceData) => {
  try {
    const res = await API.upload_invoice(invoiceData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const listInvoices = async (page, month, year, filters) => {
  try {
    const res = await API.list_invoices(page, month, year, filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


export const invoiceDetails = async (ID) => {
  try {
    const res = await API.invoice_details(ID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateInvoiceStatus = async (ID, invoiceData) => {
  try {
    const res = await API.update_invoice_status(ID, invoiceData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getActiveLedgerDetails = async ( month, year,) => {
  try {
    const res = await API.get_active_ledger_details( month, year,);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const listRerunLogs = async (page, month, year, filters) => {
  try {
    const res = await API.list_rerun_logs(page, month, year, filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const listInvoicesHistory = async (page, month, year, filters) => {
  try {
    const res = await API.list_invoices_history(page, month, year, filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadInvoice = async (ID) => {
  try {
    const res = await API.download_invoice(ID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};